import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const profitLossApi = createApi({
  reducerPath: "profitLossApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["ProfitLoss", "ProfitLossStats"],
  endpoints: (builder) => ({
    // Get all profit/loss entries
    getAllProfitLoss: builder.query({
      query: (params) => ({
        url: "/profit-loss",
        params,
      }),
      transformResponse: (response) => response.data || { entries: [] },
      providesTags: ["ProfitLoss"],
    }),

    // Get profit/loss stats
    getProfitLossStats: builder.query({
      query: (params) => ({
        url: "/profit-loss/stats",
        params,
      }),
      transformResponse: (response) => response.data || {},
      providesTags: ["ProfitLossStats"],
    }),

    // Get single entry
    getProfitLossById: builder.query({
      query: (id) => `/profit-loss/${id}`,
      transformResponse: (response) => response.data?.entry || null,
      providesTags: (result, error, id) => [{ type: "ProfitLoss", id }],
    }),

    // Create entry
    createProfitLoss: builder.mutation({
      query: (data) => ({
        url: "/profit-loss",
        method: "POST",
        body: data,
      }),
      transformResponse: (response) => response.data?.entry || response,
      invalidatesTags: ["ProfitLoss", "ProfitLossStats"],
    }),

    // Update entry
    updateProfitLoss: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/profit-loss/${id}`,
        method: "PUT",
        body: data,
      }),
      transformResponse: (response) => response.data?.entry || response,
      invalidatesTags: (result, error, { id }) => [
        { type: "ProfitLoss", id },
        "ProfitLoss",
        "ProfitLossStats",
      ],
    }),

    // Delete entry
    deleteProfitLoss: builder.mutation({
      query: (id) => ({
        url: `/profit-loss/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ProfitLoss", "ProfitLossStats"],
    }),
  }),
});

export const {
  useGetAllProfitLossQuery,
  useGetProfitLossStatsQuery,
  useGetProfitLossByIdQuery,
  useCreateProfitLossMutation,
  useUpdateProfitLossMutation,
  useDeleteProfitLossMutation,
} = profitLossApi;
